import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-dot-icon',
  templateUrl: './status-dot-icon.component.html',
  styleUrls: ['./status-dot-icon.component.scss']
})
export class StatusDotIconComponent implements OnInit {

  @Input() status: string;

  fillColor: string;

  constructor() { }


  ngOnInit() {
    // Determine status dot color based on status passed to component
    switch (this.status.toLowerCase()) {
      case 'incomplete':
        this.fillColor = '#E3B950'; // yellow
        break;
      case 'pending approval':
        this.fillColor = '#47CDFF'; // blue
        break;
      case 'completed':
        this.fillColor = '#50E3C2'; // green
        break;

      default:
        this.fillColor = '#000000'; // Black (default color)
        break;
    }
  }
}
